import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import appearenceService from "./appearanceService";

const initialState = {
  avatarStateLoading: false,
  avatarStateSuccess: false,
  avatarStateError: false,
  avatar:"",
  avatarStateErrorMsg: "",
};

// _______________________createFontSettings response function and services calling
export const createAvatarSettings = createAsyncThunk(
  "createAvatarSettings",
  async (data, thunkAPI) => {
    try {
      const response = await appearenceService.createAvatarSettings(data);
      return response;
    } catch (error) {
      // handle all error like with status code  404 or 500 or 300 , not under 200
      const errorMsg =
        (error.response &&
          error.response.data &&
          error.response.data.errorMsg) ||
        error.errorMsg ||
        error.toString();
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);

export const avatarSettingsSlice = createSlice({
  name: 'avatarSettings',
  initialState,
  reducers: {
    resetAvatarSettings: (state) => {
      state.avatarStateLoading = false;
      state.avatarStateSuccess = false;
      state.avatarStateError = false;
      state.avatarStateErrorMsg = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createAvatarSettings.pending, (state) => {
        state.avatarStateLoading = true;
      })
      .addCase(createAvatarSettings.fulfilled, (state, action) => {
        state.avatarStateLoading = false;
        state.avatarStateSuccess = true;
        state.avatar = action.payload;
      })
      .addCase(createAvatarSettings.rejected, (state, action) => {
        state.avatarStateLoading = false;
        state.avatarStateError = true;
        state.avatarStateErrorMsg = action.payload; // error from catch will come here via action.payload and update linkErrorMsg
      });
  },
});
export const { resetAvatarSettings } = avatarSettingsSlice.actions;
export default avatarSettingsSlice.reducer;